import { render, staticRenderFns } from "./MobileSimulation.vue?vue&type=template&id=2b48f9b7"
import script from "./MobileSimulation.vue?vue&type=script&lang=js"
export * from "./MobileSimulation.vue?vue&type=script&lang=js"
import style0 from "./MobileSimulation.vue?vue&type=style&index=0&id=2b48f9b7&prod&lang=less"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports